import { render, staticRenderFns } from "./auxiliar.vue?vue&type=template&id=0ff5cc0e&"
import script from "./auxiliar.vue?vue&type=script&lang=ts&"
export * from "./auxiliar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports